import React, { useState, useCallback, forwardRef, memo } from 'react'
import { GoogleMap as Map, useJsApiLoader } from '@react-google-maps/api'
import { sh, ReduxWrapper, compose } from 'common-data/datahelpers'

const GoogleMapPlain = (props, ref) => {
  const { center, containerStyle, children, onMapClick, zoom, mapProps, id } = props

  const { isLoaded } = useJsApiLoader({
    id: id || 'google-map',
    googleMapsApiKey: 'AIzaSyD3D2JlyA82sonFyXVeIgpWokPrgWHCUl4'// 'AIzaSyD3D2JlyA82sonFyXVeIgpWokPrgWHCUl4'
  })

  const [map, setMap] = useState(mapProps || null)

  const onLoad = useCallback(function callback (map) {
    const bounds = new window.google.maps.LatLngBounds(center)
    map.fitBounds(bounds)
    setMap(map)
  }, [])

  const onUnmount = useCallback(function callback (map) {
    setMap(null)
  }, [])

  return isLoaded ? (
    <Map id={id || 'google-map'}
      mapContainerStyle={containerStyle}
      center={center}
      zoom={zoom}
      onLoad={onLoad}
      onUnmount={onUnmount}
      onClick={onMapClick}
    >
      {children}
    </Map>
  ) : <></>
}

export const GoogleMap = memo(GoogleMapPlain)
